import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; 
import FieldNotificationWindow from './features/FieldNotifications/components/FieldNotificationWindow';
import EquipmentsHealthTable from './features/EquipmentHealth/components/EquipmentsHealthTable';
import './index.css'
import Login_Simplefms from './pages/Login_Simplefms';
import Select_App_Simplefms from './pages/Select_App_Simplefms';
import { Main_Application } from './pages/Main_Application';
import LoadEditor from './features/LoadEditor/components/LoadEditor';
import { Main_ApplicationTestF } from './pages/Main_ApplicationTestF';
import { EquipmentManagment } from './pages/EquipmentManagment';

function App() {
 return (
    <Router>
      <Routes>
        <Route path='/' element={<Login_Simplefms/>}/>
        <Route path='/select_app' element={<Select_App_Simplefms/>}/>
        <Route path='/main_app' element={<Main_Application/>}/>
        {/*<Route path="/field-notification-window" element={<FieldNotificationWindow />} />*/}
        {/*<Route path="/equipment-health" element={<EquipmentsHealthTable />} />*/}
        <Route path="/load-editor" element={<LoadEditor />} />
        <Route path="/main_test" element={<Main_ApplicationTestF />} />
        {/*<Route path="/equipment-managment" element={<EquipmentManagment/>} />*/}
        <Route path="/eq_m_s_m4jDA76oy" element={<EquipmentManagment/>} />
      </Routes>
    </Router>
  );
}
export default App;
